import api from './api';

// Public (no auth) — intake form + dropdown data (Task 6.1).
export const businessPublicService = {
  listPlants: () => api.get('/business/public/plants'),
  listCategories: () => api.get('/business/public/categories'),
  reportIssue: (data) => api.post('/business/public/report-issue', data),
};

// Master data admin (Task 4) — business_support_lead / superadmin only.
export const businessAdminService = {
  listPlants: () => api.get('/business/admin/plants'),
  createPlant: (d) => api.post('/business/admin/plants', d),
  updatePlant: (id, d) => api.patch(`/business/admin/plants/${id}`, d),
  listCategories: () => api.get('/business/admin/categories'),
  createCategory: (d) => api.post('/business/admin/categories', d),
  updateCategory: (id, d) => api.patch(`/business/admin/categories/${id}`, d),
  listDepartments: () => api.get('/business/admin/departments'),
  createDepartment: (d) => api.post('/business/admin/departments', d),
  updateDepartment: (id, d) => api.patch(`/business/admin/departments/${id}`, d),
  listOnboardingSteps: () => api.get('/business/admin/onboarding-steps'),
  createOnboardingStep: (d) => api.post('/business/admin/onboarding-steps', d),
  updateOnboardingStep: (id, d) => api.patch(`/business/admin/onboarding-steps/${id}`, d),
  importPreview: (formData) => api.post('/business/admin/suppliers/import/preview', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  importConfirm: (importToken) => api.post('/business/admin/suppliers/import/confirm', { importToken }),
};

// Tracker export (Task 13) — lead + viewer.
export const businessPlantService = {
  exportTracker: (plantId) => api.get(`/business/plants/${plantId}/tracker/export`, { responseType: 'blob' }),
};

// Checklist / mappings (Task 8).
export const businessMappingService = {
  list: (params) => api.get('/business/mappings', { params }),
  create: (data) => api.post('/business/mappings', data),
  update: (mappingId, data) => api.patch(`/business/mappings/${mappingId}`, data),
  remove: (mappingId) => api.delete(`/business/mappings/${mappingId}`),
  updateStep: (mappingId, stepId, data) => api.patch(`/business/mappings/${mappingId}/steps/${stepId}`, data),
};

// Suppliers (Task 6.3 picker + Task 8 detail view).
export const businessSupplierService = {
  search: (search) => api.get('/business/suppliers', { params: { search } }),
  create: (d) => api.post('/business/suppliers', d),
  update: (id, d) => api.patch(`/business/suppliers/${id}`, d),
  getById: (id) => api.get(`/business/suppliers/${id}`),
  getMappings: (id) => api.get(`/business/suppliers/${id}/mappings`),
};

// Dashboards (Task 10).
export const businessDashboardService = {
  getOnboardingFunnel: (params) => api.get('/business/dashboard/onboarding-funnel', { params }),
  getGoLiveReadiness: (params) => api.get('/business/dashboard/go-live-readiness', { params }),
  getTicketVolume: (params) => api.get('/business/dashboard/ticket-volume', { params }),
  getNeedsAttention: (params) => api.get('/business/dashboard/needs-attention', { params }),
  getSupplierCounts: () => api.get('/business/dashboard/supplier-counts'),
};

// Business tickets (Task 6).
export const businessTicketService = {
  getAll: (params) => api.get('/business/tickets', { params }),
  getById: (id) => api.get(`/business/tickets/${id}`),
  createManual: (d) => api.post('/business/tickets', d),
  update: (id, d) => api.patch(`/business/tickets/${id}`, d),
  addComment: (id, d) => api.post(`/business/tickets/${id}/comments`, d),
  notifySupplier: (id, message) => api.post(`/business/tickets/${id}/notify-supplier`, { message }),
};
